export const wrappedTokens = ['shUSDC', 'shDAI']